import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import RewindJobExecutor from '../../types/api/rewind-job-executor'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const rewindJobExecutorsApi = createApi({
    reducerPath: 'rewindJobExecutorsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['RewindJobExecutors'],
    endpoints: builder => ({
        getRewindJobExecutors: builder.query<
            Strapi<RewindJobExecutor>,
            EndpointQueryParameters | void
        >({
            query: getQuery('/rewind-job-executors'),
            providesTags: ['RewindJobExecutors'],
        }),
        createRewindJobExecutor: builder.mutation<
            StrapiSingle<RewindJobExecutor>,
            StrapiCreate<RewindJobExecutor>
        >({
            query: body => ({
                url: '/rewind-job-executors',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['RewindJobExecutors'],
        }),
        updateRewindJobExecutor: builder.mutation<
            StrapiSingle<RewindJobExecutor>,
            StrapiUpdate<RewindJobExecutor>
        >({
            query: ({ docId, body }) => ({
                url: `/rewind-job-executors/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['RewindJobExecutors'],
        }),
    }),
})

export const {
    useGetRewindJobExecutorsQuery,
    useCreateRewindJobExecutorMutation,
    useUpdateRewindJobExecutorMutation,
} = rewindJobExecutorsApi
